function getLibraryCollection(mediaFrame) {
    const state = mediaFrame?.states?.get?.('library');
    return state?.get?.('library') || null;
}

function getDisplayedBrowseCollection(mediaFrame) {
    const view = mediaFrame?.content?.get?.();
    if (view?.collection) return view.collection;
    if (view?.attachments) return view.attachments;
    return null;
}

function addToCollections(mediaFrame, model, options = {at: 0, merge: true}) {
    const library = getLibraryCollection(mediaFrame);
    const displayed = getDisplayedBrowseCollection(mediaFrame);

    if (library) library.add(model, options);
    if (displayed && displayed !== library) displayed.add(model, options);
}

function removeFromCollections(mediaFrame, model) {
    const library = getLibraryCollection(mediaFrame);
    const displayed = getDisplayedBrowseCollection(mediaFrame);

    if (library) library.remove(model);
    if (displayed && displayed !== library) displayed.remove(model);
}

function setBrowseMode(mediaFrame) {
    if (mediaFrame?.content?.mode) {
        mediaFrame.content.mode('browse');
    }
}

export function bindUploaderConfig(mediaFrame, uploaderConfig) {
    if (!uploaderConfig) return;

    let bound = false;
    const placeholderByFileId = new Map();

    const setup = function () {
        if (bound) return;

        const wpUploaderView = mediaFrame.uploader?.uploader;
        if (!wpUploaderView) return;

        bound = true;

        Object.entries(uploaderConfig).forEach(([key, value]) => {
            wpUploaderView.param(key, value);
        });

        const plupload = wpUploaderView?.uploader;
        if (!plupload?.bind) return;

        plupload.bind('FilesAdded', function (up, files) {
            setBrowseMode(mediaFrame);

            const list = Array.isArray(files) ? files : (files ? [files] : []);

            list.forEach((file) => {
                if (!file?.id) return;

                const placeholder = new wp.media.model.Attachment({
                    id: `placeholder-${file.id}`,
                    uploading: true,
                    percent: 0,
                    filename: file.name || '',
                    title: file.name || '',
                    type: (file.type || '').startsWith('image/') ? 'image' : '',
                });

                placeholderByFileId.set(file.id, placeholder);
                addToCollections(mediaFrame, placeholder, {at: 0, merge: false});
            });
        });

        plupload.bind('UploadProgress', function (up, file) {
            const placeholder = file?.id ? placeholderByFileId.get(file.id) : null;
            if (placeholder) placeholder.set('percent', file?.percent || 0);
        });

        plupload.bind('FileUploaded', function (up, file, response) {
            const placeholder = file?.id ? placeholderByFileId.get(file.id) : null;
            if (!placeholder) return;

            let attachmentId = null;
            try {
                const json = typeof response.response === 'string'
                    ? JSON.parse(response.response)
                    : response.response;

                attachmentId = json?.data?.attachment?.id || json?.data?.id || null;
            } catch (e) {
                console.error('Parse error:', e);
            }

            if (!attachmentId) {
                removeFromCollections(mediaFrame, placeholder);
                placeholderByFileId.delete(file.id);
                return;
            }

            const model = wp.media.model.Attachment.get(attachmentId);

            model.fetch().done(() => {
                removeFromCollections(mediaFrame, placeholder);

                addToCollections(mediaFrame, model, {at: 0, merge: true});

                const selection = mediaFrame.state().get('selection');
                if (selection && !selection.get(model.id)) {
                    selection.add(model);
                }

                placeholderByFileId.delete(file.id);
            }).fail(() => {
                removeFromCollections(mediaFrame, placeholder);
                placeholderByFileId.delete(file.id);
            });
        });

        plupload.bind('Error', function (up, err) {
            const fileId = err?.file?.id;
            const placeholder = fileId ? placeholderByFileId.get(fileId) : null;

            if (placeholder) {
                placeholder.set({uploading: false, error: true});
            }
        });
    };

    mediaFrame.on('uploader:ready', setup);
    mediaFrame.on('content:render:upload', setup);
}
